import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Box, Typography, TextField, Button } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { customTextColor, shortDateTime } from "../../utils/const";
import { useDispatch, useSelector } from "react-redux";
import {
  getHotLists,
  getRecruiterList,
  shareHotListToRecruiter,
} from "../../redux/hotlist/hotListSlice";
import { fetchMyCredit } from "../../redux/credit/creditSlice";

const ShareHotlistDrawer = ({ show, handleClose, hotlist, credit }) => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [filterTerm, setFilterTerm] = useState("");
  const [selectedRecruiter, setSelectedRecruiter] = useState(null);
  const hotListData = useSelector((state) => state.hotlist);
  const { recruiters } = hotListData;

  // Filter recruiters based on filterTerm
  const filteredRecruiters = recruiters.filter(
    (recruiter) =>
      recruiter.full_name.toLowerCase().includes(filterTerm.toLowerCase()) ||
      recruiter.company_name.toLowerCase().includes(filterTerm.toLowerCase()) ||
      (recruiter.rectuiter_details?.email || "")
        .toLowerCase()
        .includes(filterTerm.toLowerCase())
  );

  useEffect(() => {
    if (hotlist?.id) {
      dispatch(getRecruiterList(hotlist.id));
    }
  }, [dispatch, hotlist?.id]);

  const handleSearch = () => {
    setFilterTerm(searchTerm);
  };

  // const handleSendHotlist = (recruiter) => {
  //   if (recruiter) {
  //     console.log(`Sending hotlist to ${recruiter.full_name}`);
  //     const hotlistData = {
  //       hot_list_id: hotlist?.id,
  //       recruiter_ids: [recruiter.recruiter_id],
  //     };
  //     dispatch(shareHotListToRecruiter(hotlistData));
  //     dispatch(getRecruiterList(hotlist.id));
  //     dispatch(getHotLists());
  //     // handleClose();
  //   }
  // };
  const handleSendHotlist = async (recruiter) => {
    if (recruiter) {
      console.log(`Sending hotlist to ${recruiter.full_name}`);
      const hotlistData = {
        hot_list_id: hotlist?.id,
        recruiter_ids: [recruiter.recruiter_id],
      };

      try {
        const result = await dispatch(shareHotListToRecruiter(hotlistData));

        if (shareHotListToRecruiter.fulfilled.match(result)) {
          dispatch(getRecruiterList(hotlist.id));
          dispatch(getHotLists());
          dispatch(fetchMyCredit());
          // handleClose(); // if needed
        } else {
          console.error("Failed to share hotlist");
        }
      } catch (err) {
        console.error("Error sending hotlist:", err);
      }
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={true}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "50%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ padding: "10px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "0px 5px",
            }}
          >
            <RxCross2
              style={{
                fontSize: "15px",
                cursor: "pointer",
                color: customTextColor,
              }}
              onClick={handleClose}
            />
          </Box>
          <Box sx={{ padding: "0px 10px" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "10px",
              }}
            >
              <Box>
                <TextField
                  label="IT Recruiter Name or ID | Company Name"
                  variant="outlined"
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{
                    maxWidth: "400px",
                    minWidth: "280px",
                    flexGrow: 1,
                    mr: 1,
                  }}
                />
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  sx={{
                    backgroundColor: "#00b0f0",
                    textTransform: "capitalize",
                    borderRadius: "3px",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#0085b4",
                      boxShadow: "none",
                    },
                  }}
                >
                  Search
                </Button>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  style={{
                    color: customTextColor,
                  }}
                  variant="h5"
                >
                  <b>{credit}</b>
                </Typography>
                <Typography
                  style={{ color: customTextColor }}
                  variant="caption"
                >
                  Credit Available
                </Typography>
              </Box>
            </Box>
            {filteredRecruiters.map((recruiter) => (
              <Box
                key={recruiter.recruiter_id}
                sx={{
                  padding: "5px 10px",
                  border: "1px solid #e0e0e0",
                  display: "flex",
                  mb: "10px",
                  borderRadius: "3px",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography>{recruiter.full_name}</Typography>
                  <Typography variant="body2">
                    {recruiter.designation || recruiter.rectuiter_details?.role}{" "}
                    – {recruiter.company_name}
                  </Typography>
                  <Typography variant="body2">
                    {recruiter.rectuiter_details?.email || "N/A"}
                  </Typography>
                  <Typography variant="body2">
                    {recruiter.rectuiter_details?.mobile_no || "N/A"}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: "8px",
                  }}
                >
                  <Typography variant="caption">
                    <b>Active Since</b>{" "}
                    {shortDateTime(recruiter?.updated_at) || "N/A"}
                  </Typography>
                  <Button
                    variant="contained"
                    disabled={recruiter.is_shared}
                    onClick={() => {
                      setSelectedRecruiter(recruiter);
                      handleSendHotlist(recruiter);
                    }}
                    sx={{
                      backgroundColor: recruiter.is_shared ? "#ccc" : "#00b0f0",
                      textTransform: "capitalize",
                      borderRadius: "3px",
                      boxShadow: "none",
                      "&:hover": {
                        backgroundColor: recruiter.is_shared
                          ? "#ccc"
                          : "#0085b4",
                        boxShadow: "none",
                      },
                    }}
                  >
                    {recruiter.is_shared ? "Shared" : "Send Hotlist"}
                  </Button>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ShareHotlistDrawer;
